<template>
    <div class="custom-control custom-checkbox image-checkbox text-center">
        <input
            type="checkbox"
            class="custom-control-input color-check-renault"
            :value="inputValue"
            v-model="model"
        />
            
        <label class="custom-control-label" for="ck1a">
            <template
                v-if="
                    item.extension === 'webp' ||
                    item.extension === 'jpg' ||
                    item.extension === 'jpeg' ||
                    item.extension === 'jfif' ||
                    item.extension === 'png' ||
                    item.extension === 'gif'
                "
            >
                <img
                    class="img-galeria-renault"
                    :src="item.versions.thumb"
                />
                <div class="media-overlay">
                    <div class="shadow-overlay"></div>
                    <span class="preview-button">
                        <a
                            :href="item.versions.sd"
                            class="text-decoration-none fw-600 text-white"
                            data-lightbox="photos"
                            ><i class="fa-solid fa-magnifying-glass"></i
                        ></a>
                    </span>
                    <span class="download-buttons bottom-0">
                            <a
                                :href="apiBaseUrl + 'media/downloadSingle?uuid=' + item.uuid + '&conversion=sd'"
                                class="text-decoration-none text-white"
                                >SD<img
                                    src="/img/icono-flecha-download-blanca.svg"
                                    width="20"
                            /></a>
                            <a
                                :href="apiBaseUrl + 'media/downloadSingle?uuid=' + item.uuid"
                                class="text-decoration-none text-white"
                                >HD<img
                                    src="/img/icono-flecha-download-blanca.svg"
                                    width="20"
                            /></a>
                    </span>
                </div>
            </template>

            <template
                v-if="item.extension === 'pdf' || item.extension === 'docx'"
            >
                <figure class="figure">
                    <img
                        src="/img/document_default.png"
                        class="figure-img img-galeria-renault"
                        :alt="item.name"
                    />
                    <figcaption class="figure-caption">
                        {{ item.file_name }}
                    </figcaption>
                </figure>
            </template>
            <template v-if="item.extension === 'mp4' || item.extension === 'avi' || item.extension === 'mov'">
                <div class="embed-responsive embed-responsive-16by9">
                    <span class="download-buttons top-0">
                        <a
                            :href="apiBaseUrl + 'media/downloadSingle?uuid=' + item.uuid"
                            class="text-decoration-none text-white"
                            >HD<img
                                src="/img/icono-flecha-download-blanca.svg"
                                width="20"
                        /></a>
                    </span>
                    <figure class="figure">
                        <video
                            class="img-galeria-renault"
                            :src="item.versions.original"
                            controls
                            controlsList="nodownload"
                            preload="metadata"
                            :poster="item.versions.thumb"
                        ></video>
                        <figcaption v-if="item.name" class="figure-caption fs-6">{{item.name}} ({{niceBytes(item.size)}})</figcaption>
                    </figure>
                </div>
            </template>
        </label>
    </div>
</template>

<style scoped>
.figure-caption {
    word-break: break-word;
}
</style>

<script>
export default {
    props: {
        item: Object,
        label: String,
        value: Array,
        inputValue: String,
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
        apiBaseUrl: {
            get() {
                return process.env.MIX_API_URL;
            }
        }
    },
    methods: {
        niceBytes: function (x){
            const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            let l = 0, n = parseInt(x, 10) || 0;
            
            while(n >= 1024 && ++l){
                n = n/1024;
            }

            return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
        }
    },
    mounted() {

    },
};
</script>
